<div class="wrapper">
  <div class="contentWrapper {{smallMode ? 'small': ''}}">
    <tun-lock-large-icon-v5 class="largeIcon"></tun-lock-large-icon-v5>
    <div class="infoText">
      {{ message }}
    </div>
  </div>
</div>
